export const siteInfo = {
  name: "Sarita's Cafe & Bistro",
  siteUrl: 'https://saritas.ch',
  defaultTitle: "Sarita's - Cafe & Bistro in Hinwil",
  defaultDescription: "Sarita's ist ein Cafe und Bistro am Bahnhofplatz 1 in Hinwil mit Kaffee, hausgemachten Cheesecakes, Brunch, Lunch und Take-away.",
  locale: 'de_CH',
  addressLine1: 'Bahnhofplatz 1',
  addressLine2: '8340 Hinwil',
  streetAddress: 'Bahnhofplatz 1',
  postalCode: '8340',
  addressLocality: 'Hinwil',
  addressCountry: 'CH',
  phone: '076 475 66 48',
  phoneIntl: '+41 76 475 66 48',
  phoneHref: 'tel:+41764756648',
  email: 'kafi@saritas.ch',
  instagramHandle: '@saritascafehinwil',
  instagramUrl: 'https://www.instagram.com/saritascafehinwil/',
  ogImagePath: '/Sartias_Logo_complete.svg',
  mapQuery: 'Sarita\'s Café & Bistro',
  openingHours: [
    {
      days: 'Mo - Di',
      hours: '06:30 - 13:30',
      opens: '06:30',
      closes: '13:30',
      schemaDays: ['Monday', 'Tuesday']
    },
    {
      days: 'Mi - Fr',
      hours: '06:30 - 18:00',
      opens: '06:30',
      closes: '18:00',
      schemaDays: ['Wednesday', 'Thursday', 'Friday']
    },
    {
      days: 'Sa - So',
      hours: '09:00 - 17:00',
      opens: '09:00',
      closes: '17:00',
      schemaDays: ['Saturday', 'Sunday']
    }
  ],
  specialOpeningHours: [
    { date: '2026-12-24', displayDate: '24. Dezember 2026', status: 'Geschlossen' },
    { date: '2026-12-25', displayDate: '25. Dezember 2026', name: 'Weihnachtstag', status: 'Geschlossen' },
    { date: '2026-12-26', displayDate: '26. Dezember 2026', name: 'Stephanstag', status: 'Geschlossen' }
  ]
};

export function getZurichDateKey(date = new Date()) {
  const parts = new Intl.DateTimeFormat('de-CH', {
    timeZone: 'Europe/Zurich',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
  const valueFor = (type) => parts.find((part) => part.type === type)?.value;

  return `${valueFor('year')}-${valueFor('month')}-${valueFor('day')}`;
}

export function getSpecialOpeningHoursForDate(date = new Date()) {
  const dateKey = getZurichDateKey(date);
  return siteInfo.specialOpeningHours.find((entry) => entry.date === dateKey) ?? null;
}
